import customAxios from './interceptors';

const getMediumData = (mediumNumber: string, tenantId: string) => {
  return customAxios.get(`${process.env.REACT_APP_API_URL}/mediumdata/${tenantId}/${encodeURIComponent(mediumNumber)}`);
}

export default getMediumData;
